import { render, staticRenderFns } from "./Top10Chart.vue?vue&type=template&id=3b1c698c&scoped=true&"
import script from "./Top10Chart.vue?vue&type=script&lang=js&"
export * from "./Top10Chart.vue?vue&type=script&lang=js&"
import style0 from "./Top10Chart.vue?vue&type=style&index=0&id=3b1c698c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1c698c",
  null
  
)

export default component.exports